// Unpublished Work © 2021-2024 Deere & Company.

export default {
    start: 'start',
    unpause: 'unpause',
    pause: 'pause',
    stop: 'stop'
};
